import { IMetadataItemDto } from "../../settings/documentfields/metadata-item.dto";
import { IField } from "../../settings/documenttype/document-type-settings-modal/document-type-settings.dto";

export interface IDocumentPreviewColumns {
    type?: string
    doc_id?: number,
    label?: string,
    field_name?: string,
    status?: number,
    order?: number
}
export interface IPinnedField extends IField{
  meta_data: IMetadataItemDto
}

export const documentPreviewColumns: IDocumentPreviewColumns[] = [
    {
      type: 'default',
      doc_id: null,
      label: "Document type",
      field_name: "document_type",
      status: 1,
      order: 0
    },  
    {
      type: 'default',
      doc_id: null,
      label: "Category",
      field_name: "category_name",
      status: 1,
      order: 1
    },  
    {
      type: 'default',
      doc_id: null,
      label: "Get shareable link",
      field_name: "get_shareable_link",
      status: 1,
      order: 2
    },
    {
      type: 'default',
      doc_id: null,
      label: "Linked with",
      field_name: "linked_with",
      status: 1,
      order: 3
    },  
    {
      type: 'default',
      doc_id: null,
      label: "Due date",
      field_name: "due_date",
      status: 1,
      order: 4
    },  
    {
      type: 'default',
      doc_id: null,
      label: "Document owner",
      field_name: "document_owner",
      status: 1,
      order: 5
    },  
    {
      type: 'default',
      doc_id: null,
      label: "Latest Activity",
      field_name: "status_updated_at",
      status: 1,
      order: 6
    }
  ];
